import { createSelector } from '@reduxjs/toolkit'

import { getCockpitCategoriesByOffering } from '../../lib/getCockpitCategoriesByOffering'

import { selectCockpitActualsAndTargetsSettings } from './selectCockpitActualsAndTargetsSettings'

export const selectCockpitCategoriesByOffering = createSelector(
  selectCockpitActualsAndTargetsSettings,
  getCockpitCategoriesByOffering
)
